import React from 'react';

const SearchUserInfo = () => {
  return <div>SearchUserInfo</div>;
};

export default SearchUserInfo;
